import 'react';
import { useTheme, jsx } from '@emotion/react';
import Style from './style.js';

var getStyles = _ref => {
  var {
    isLowContrast,
    status,
    theme
  } = _ref;
  // Default colors are primary
  var backgroundColor = theme.COLORS.primary;
  var textColor = theme.COLORS.white;

  if (status === 'primary' && isLowContrast) {
    backgroundColor = theme.COLORS.defaultLight;
    textColor = theme.COLORS.primary;
  }

  if (status === 'error') {
    backgroundColor = theme.COLORS.error;
    textColor = theme.COLORS.white;

    if (isLowContrast) {
      backgroundColor = theme.COLORS.errorLight;
      textColor = theme.COLORS.error;
    }
  }

  if (status === 'success') {
    backgroundColor = theme.COLORS.success;
    textColor = theme.COLORS.white;

    if (isLowContrast) {
      backgroundColor = theme.COLORS.successBorder;
      textColor = theme.COLORS.success;
    }
  }

  if (status === 'info') {
    backgroundColor = theme.COLORS.info;
    textColor = theme.COLORS.white;

    if (isLowContrast) {
      backgroundColor = theme.COLORS.infoLight;
      textColor = theme.COLORS.info;
    }
  }

  if (status === 'white') {
    /**
     * No low-contrast version of white variation
     */
    backgroundColor = theme.COLORS.white;
    textColor = theme.COLORS.primary;
  }

  return {
    backgroundColor,
    textColor
  };
};
/**
 * Chips should be used in small spaces to add value to the elements they're nested in. (i.e. "Recommended" on product cards or showing an error on an element in a list.)
 *
 * These chips can have a status value of Error, Primary, Success, or White. "White" does not have a low contrast version, and can be used on top of photos or illustrations.
 */


var Chip = _ref2 => {
  var {
    isLowContrast = false,
    status = 'primary',
    text
  } = _ref2;
  var theme = useTheme();
  var {
    backgroundColor,
    textColor
  } = getStyles({
    isLowContrast,
    status,
    theme
  });
  return jsx(Style.ChipStyles, {
    backgroundColor: backgroundColor,
    textColor: textColor
  }, jsx(Style.ChipText, null, text));
};

export { Chip };
